import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import i18n from "./plugins/i18n";
import { initAnalytics } from "./plugins/firebase";
import {
  rehydrateFromCookies,
  syncLocalStorageToCookies,
} from "./utils/cookieBackup";
import "./views/MiaAi/styles/mia-theme.css";
import "./styles/sweetalert-global.css";
import "./styles/cart-toast.css";
import "./styles/empty-cart.css";

// Rehydrate localStorage from cookies before any auth checks
// This restores auth values if localStorage was cleared by the browser
rehydrateFromCookies();

// Sync existing localStorage values to cookies (ensures backup is current)
syncLocalStorageToCookies();

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);

// استرجاع القيم من localStorage
const savedRegion = localStorage.getItem("selectedRegion");
const savedCurrency = localStorage.getItem("selectedCurrency");

// معالجة الريجون
if (savedRegion && savedRegion !== "null") {
  window.appRegion = JSON.parse(savedRegion);
} else {
  window.appRegion = {};
}

// 🔹 ضمان وجود phone_code دايمًا
if (!("phone_code" in window.appRegion)) {
  window.appRegion.phone_code = null;
}

// معالجة العملة
if (savedCurrency && savedCurrency !== "null") {
  window.appCurrency = savedCurrency;
} else {
  window.appCurrency = null;
}

// تخزين في globalProperties
app.config.globalProperties.$appCurrency = window.appCurrency;
app.config.globalProperties.$appRegion = window.appRegion;

// تشغيل التطبيق
app.mount("#app");

// 🔹 التحقق من وجود الريجون والعملة (واستبعاد حالة null) - بعد mount
if (!window.appCurrency) {
  router.push("/select-region");
}

initAnalytics();
